import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-semibold text-primary-600 uppercase tracking-wider mb-3">
            Beliebte Kategorien
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-4">
            Durchsuche alle Fashion-Kategorien
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Finde genau das, was du suchst. Von Sneakern bis zu Parfums – unser OOPBuy Spreadsheet deckt alle Bereiche ab.
          </p>
        </div>

        {/* Category Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300/60 transition-all duration-300 hover:shadow-sm"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.nameDe}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3 text-center">
                <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-700 transition-colors">
                  {cat.nameDe}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5 hidden sm:block">
                  {cat.name}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}